module.exports = __webpack_public_path__ + "4ad5dbc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/alert.png
// module id = 2055
// module chunks = 18 19 32 37